import type { SelectProps } from '@mantine/core'
import { Select } from '@mantine/core'

import classes from './SelectInput.module.css'

export function SelectInput({ ...props }: SelectProps) {
  return <Select className={classes.selectInput} {...props} />
}
